/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import {
  PEOPLE_GUEST_ROUTE,
} from "../../constants/routes";

/* Components */
import Breadcrumbs from "../breadcrumbs";

/* Styles */
import styles from "./styles.js";

const GuestProfileHeader = ({ guestId, guestDetails }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  
  let userRowDetails;
  if (location?.state) {
    userRowDetails = location.state.userRowDetails
  }
  
  const getBreadcrumbs = () => {
    if (!guestId) {
      return (
        <FormattedMessage id="breadcrumbs.createGuest"/>
      )
    } else if (guestDetails && Object.keys(guestDetails).length) {
      return guestDetails?.firstName + " " + guestDetails?.lastName
    } else if (userRowDetails) {
      return userRowDetails?.firstName + " " + userRowDetails?.lastName
    } else {
      return (
        <Skeleton
          count={1}
          width={205}
          className={classes.skeletonName}
        />
      )
    }
  }
  
  const getTitle = () => {
    if (!guestId) {
      return (
        <FormattedMessage id="guest.createTitle"/>
      )
    } else if (guestDetails && Object.keys(guestDetails).length) {
      return (
        <FormattedMessage
          id="guest.editTitle"
          values={{
            firstName: guestDetails?.firstName,
            lastName: guestDetails?.lastName
          }}
        />
      )
    } else if (userRowDetails) {
      return userRowDetails?.firstName + " " + userRowDetails?.lastName
    } else {
      return (
        <Skeleton
          count={1}
          width={305}
          className={classes.skeletonName}
        />
      )
    }
  }
  
  return (
    <div className={classes.peoplePageHeader}>
      <Breadcrumbs
        items={[
          <Link to={PEOPLE_GUEST_ROUTE}>
            <FormattedMessage id="breadcrumbs.guest"/>
          </Link>,
          getBreadcrumbs()
        ]}
      />
      <Container className={classes.container}>
        <Row>
          <Col xs={12} className='gx-0'>
            <div className={classes.titleBadgeWrapper}>
              <h1 className={classes.title}>
                {getTitle()}
              </h1>
              <span className={classes.subtitle}>
                <FormattedMessage id={!guestId ? "guest.createSubtitle" : "guest.editSubtitle"}/>
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default GuestProfileHeader;
